/* eslint-disable no-restricted-properties */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable default-case */
/* eslint-disable consistent-return */
/* eslint-disable  */
import React from 'react';
import {
  ListItemIcon,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import { usePresenceTimer, TimerState } from '../../GlobalHooks/usePresenceTimer';
import {
  FiberManualRecord as Circle,
  RemoveCircle,
} from "@material-ui/icons";
import EXicon from '../../icons/EX.png';
//import { dotRenderer } from '../../Profile';

export type StatusPresentation =
  | { kind: "InStatus"; status: string }
  | { kind: "Syncing";   status: string}
  | { kind: "Pending";   status: string }
  | { kind: "Error";     status: string; message: string };



interface PresenceTimerData {
  timerStart: number;
  timerEnd: number;
  duration: number;
  autoSwitchback: boolean;
  userDisplay: string;
}

interface Props {
  accountId: string;
  userId: string;
  display: string;
  cxUser: boolean
  lightMode: boolean;
  idToken: string;

  statusPresentation: StatusPresentation;

  timeElapsed: string | number | undefined;
  
  // New props for timer data from websocket
  presenceTimerData?: PresenceTimerData;
  late?: boolean;
}

 const ExPresence: React.FC<Props> = ({
  accountId,
  userId,
  display,
  cxUser,
  lightMode,
    idToken,
    statusPresentation,
    timeElapsed,
    presenceTimerData,
    late = false
}) => {
    // Use the centralized presence timer hook
    const { timerState } = usePresenceTimer({
      presenceTimerData,
      late,
      elapsedTime: "full", // ExPresence always uses full format
      offset: 0, // ExPresence doesn't use offset
      display
    });
  
    // 1) handle status‐change UI
    if (statusPresentation.kind === "Syncing") {
      return <SpinnerWithText text="Syncing with RingCentral…" />;
    }
    if (statusPresentation.kind === "Pending") {
        
        const txt = `${statusPresentation.status}…`;
      return <SpinnerWithText text={txt} />;
    }
    if (statusPresentation.kind === "Error") {
      return <SpinnerWithText text={statusPresentation.message} />;
    }
  
    // 2) now we know we're InStatus → render icon + name + timer

    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: (cxUser !== undefined) ? "start" : "center" }}>
          {cxUser && (
            <Tooltip title="EX">
              <img src={EXicon} alt="EX icon" style={{ width:20, marginRight:4, filter: lightMode ? "brightness(50%)" : "invert(1)" }} />
            </Tooltip>
          )}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "start", marginLeft: 10}}>
          <ListItemIcon style={{ minWidth: 14 }}>{dotRenderer(display, late)}</ListItemIcon>
          <span style={{ marginRight: 8, color: colorRenderer(display, late)}}>{display.substring(4)}</span>
    
          {/* 3) handle the timer union - only show timer if in timed status and timer data matches current display */}
          {presenceTimerData && presenceTimerData.userDisplay === display && (() => {
           // console.log('ExPresence: Rendering timer', { 
           //   timerState: timerState.kind, 
           //   hasTimerData: presenceTimerData, 
           //   displayMatch: presenceTimerData?.userDisplay === display,
           //   late
           // });
            
            switch (timerState.kind) {
              case "NoTimer":
                return null;

              case "TimerOn":
                return <TimerDisplay delta={timerState.timeDelta} />;
                
              case "OverStaying":
                // Only show late timer if colorRenderer(display, late) === blue
                if (colorRenderer(display, late) === blue) {
                  return <TimerDisplay delta={timerState.timeDelta} prefix=" — Over by " color={blue} />;
                }
                return null;
                
              default:
                return null;
            }
          })()}
        </div>
        </div>
        {/* Show timeElapsed when there's no active timer and not in a late condition */}
        {timerState.kind === "NoTimer" && !late && (
          <div>{timeElapsed}</div>
        )}
      </div>
    );
  };
  
  // small helpers, implement as you like
  const SpinnerWithText: React.FC<{ text: string; size?: number }> = ({ text, size = 20 }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <CircularProgress size={size} style={{ marginRight: 4 }} />
      <span>{text}</span>
    </div>
  );
  
  export const TimerDisplay = ({ delta, prefix = "", color }: { delta: number; prefix?: string; color?: string }) => {
    const abs = Math.abs(delta);
    const m = Math.floor(abs / 60000);
    const s = String(Math.floor((abs % 60000) / 1000)).padStart(2, "0");
    return <span style={{ color: color }}>{prefix}{m}:{s}</span>;
  };
  
  export default ExPresence;

  const green = "#00b160";
  const red = "#ff4e4e";
  const yellow = "#f7b500";
  const gray = "#9c9c9c";
  const blue = "#1e90ff";
  
  export const dotRenderer = (display: string, late?: boolean) => {//
    if ( display === undefined || display.startsWith("AVL")) {
      return (
        <Circle
          style={{ color: green, fontSize: "1.2rem", marginRight: 3 }}
          aria-label="Available icon"
          aria-hidden={false}
          role="img"
        />
      );
    }
    if (display.startsWith("DND")) {
      // Always show red RemoveCircle for DND statuses, regardless of late state
      return (
        <RemoveCircle
          aria-label="Do not disturb icon"
          aria-hidden={false}
          role="img"
          style={{ color: red, fontSize: "1.2rem", marginRight: 3 }}
        />
      );
    }
  
    if (display.startsWith("INV")) {
      return (
        <Circle
          style={{ color: gray, fontSize: "1.2rem", marginRight: 3  }}
          aria-label="Invisible icon"
          aria-hidden={false}
          role="img"
        />
      );
    }
  
    if (display.startsWith("BSY")) {
      return (
        <Circle
          style={{ color: red, fontSize: "1.2rem", marginRight: 3  }}
          aria-label="Busy icon"
          aria-hidden={false}
          role="img"
        />
      );
    }
    return "";
  }

  export const colorRenderer = (status: string, late?: boolean): string => {
    if (status === undefined || status.startsWith("AVL")) return green;
    if (status.startsWith("DND") && late) return blue;
    if (status.startsWith("DND") || status.startsWith("BSY")) return red;
    if (status.startsWith("INV")) return gray;
    return "green"
  }